export class UnsupportedDate { }

export class UnsupportedWildcardLocation { }